import SwaggerUI from 'swagger-ui-react';
import 'swagger-ui-react/swagger-ui.css';

/**
 * Public developer portal — renders the platform's OpenAPI spec for
 * external integrators. No login, no workspace context.
 *
 * The OpenAPI YAML at `/openapi.yaml` is copied from the repo's
 * `docs/openapi.yaml` at build time by `scripts/copy-openapi.mjs`.
 * That file is the canonical source of truth — edits there flow to
 * this site on every build.
 */
export function Developers() {
  return (
    <div style={{ minHeight: '100vh', background: '#fafafa' }}>
      <header
        style={{
          background: '#0B0F1A',
          padding: '28px 32px',
          display: 'flex',
          alignItems: 'flex-end',
          justifyContent: 'space-between',
          gap: 16,
        }}
      >
        <div>
          <div style={{ display: 'flex', alignItems: 'baseline', gap: 10 }}>
            <span style={{ fontWeight: 800, fontStyle: 'italic', fontSize: 26, letterSpacing: '-0.03em', color: '#00E37A' }}>Go</span>
          </div>
          <h1 style={{ fontSize: 24, fontWeight: 700, margin: '10px 0 0', color: '#fff' }}>Developer API</h1>
          <div style={{ fontSize: 14, color: '#C8D0DC', marginTop: 4 }}>
            External HTTP endpoints exposed by Go.
          </div>
        </div>
        <div style={{ fontSize: 12, color: '#6B7488' }}>
          Source: <a href="/openapi.yaml" style={{ color: '#00E37A' }}>/openapi.yaml</a>
        </div>
      </header>

      <main style={{ padding: '24px 32px' }}>
        <div style={{ background: '#fff', borderRadius: 8, border: '1px solid #e5e7eb', overflow: 'hidden' }}>
          <SwaggerUI url="/openapi.yaml" docExpansion="list" />
        </div>
      </main>
    </div>
  );
}
